import { RouteService } from 'app/services/route.service';
import { TranslationService } from 'app/services/translation.service';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {Task} from '../../entities/Task';
import {NotificationService} from '../../services/notification.service';
import {AppTaskCategory} from '../../entities/AppTaskCategory';
import {LoginService} from '../../services/login.service';
import {TaskActivity} from '../../entities/TaskActivity';
import {TaskService} from '../../services/task.service';
import {TaskActivityService} from '../../services/task-activity.service';
import {FilterModel} from '../../entities/FilterModel';
import {MaintenanceObjectService} from '../../services/maintenance-object.service';
import {MaintenanceObject_DTO} from '../../entities/MaintenanceObject_DTO';
import {SalesPersonService} from '../../services/sales-person.service';
import {Responsible} from '../../entities/SalesPerson';
import { ConfigService } from 'app/services/config.service';
import { Translation } from 'app/entities/Translation';

@Component({
  selector: 'app-notification-overview',
  templateUrl: './notification-overview.component.html',
  styleUrls: ['./notification-overview.component.css']
})
export class NotificationOverviewComponent implements OnInit, OnDestroy {

  public notifications: any[] = [];
  public loggedInUserNo: string;
  public lastUsedFilterModel: FilterModel;
  public navigationDate: Date;
  public appTaskCategories: AppTaskCategory[];
  public maintenanceObjectDTO: MaintenanceObject_DTO;
  public salespersons: Responsible[];
  public companies: any[];
  translationsLoaded: boolean = false;
  translations: Map<string, Translation>;


  constructor(private notificationService: NotificationService,
              private loginService: LoginService,
              private taskservice: TaskService,
              private activityService: TaskActivityService,
              private maintenanceObjectService: MaintenanceObjectService,
              private salesPersonService: SalesPersonService,
              private translationService: TranslationService,
              private routeService: RouteService,
              private config: ConfigService,
              ) {
  }

  ngOnInit() {
    this.loggedInUserNo = this.loginService.getLoggedInUserID();
    this.navigationDate = new Date();
    this.initInitialData();
    this.setTranslations();
    $('body').css('overflow', 'hidden')
  }

  ngOnDestroy() {
    $('body').css('overflow', 'auto');
  }

  GetNotifications(filterModel: FilterModel = null) {
    if (filterModel != null) {
      this.lastUsedFilterModel = filterModel;
    }
    this.notificationService.GetAll(this.lastUsedFilterModel).subscribe(result => {
      this.notifications = result;
    });
  }

  CreateNotification(notification: any) {
    this.notificationService.Post(notification, notification.Company_Reference).subscribe(x => {
      this.GetNotifications();
    });
  }

  UpdateNotification(notification: any) {
    let company = notification.Company_Reference;
    notification.Company_Reference = null;
    this.notificationService.Put(notification, company).subscribe(x => {
      this.GetNotifications();
    })
  }

  // Calls the service to save the updated task data, after converting the dateTime.
  updateTask(taskToUpdate: Task) {
    this.taskservice.putTaskInfo(taskToUpdate).subscribe();
  }

  /***
   * This method is called when a Task Activities is updated
   * @param activities
   */
  updateActivities(activities: TaskActivity[]) {

    this.activityService.putTaskActivities(activities).subscribe();
  }


  private initInitialData() {
    this.notificationService.GetTaskCategories().subscribe(x => {
      this.appTaskCategories = x;
    });

    this.maintenanceObjectService.Get(null, null, true, true).subscribe(x => {
      this.maintenanceObjectDTO = x;
    });
    const salesPersonSub = this.salesPersonService.getAllSalesPersonsAsSalesPerson().subscribe(result => {
      if (result.length > 0) {
        this.salespersons = result;
      }
    }, error =>  {}, () => {salesPersonSub.unsubscribe()});
    const companiesSub = this.loginService.getCompanies().subscribe(
      resp => {this.companies = resp;},
      error => {},
      () => {companiesSub.unsubscribe()})
  }

  setTranslations() {
    this.translationService.loadTranslations();
    this.translationService.translationsSub.subscribe(translations => {
      // Get translations from the service
      if (translations !== null && Object.keys(translations).length > 0) {
        // Check to make sure that translations is loaded and in the correct language
        this.translationService.getLanguageSubject().subscribe(language => {
          // This check is done to only set translationsLoaded if the language in the translation object matches the active language. Sometimes it returns the old language object as the first call
          if (language == translations[Object.keys(translations)[0]].Language_Code) {
            this.translationsLoaded = true
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/notification-overview/notification-overview.component.ts